import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, NgZone, Output, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { isNullOrUndefined } from 'util';
import { process } from '@progress/kendo-data-query';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CLPUser, SFAResponse, UserResponse } from '../../../../models/clpuser.model';
import { RoleFeaturePermissions } from '../../../../models/roleContainer.model';
import { Contact, ContactList, ContactListResponse, ContactResponse } from '../../../../models/contact.model';
import { BulckAction, BulkActionResponse } from '../../../../models/bulkActionContact';
import { GridConfigurationService } from '../../../../services/shared/gridConfiguration.service';
import { ContactCommonSearchService } from '../../../../services/shared/contact-common-search.service';
import { keyValue, SearchQueryResponse } from '../../../../models/search.model';
import { BulkActionContactService } from '../../../../services/bulk-action-contact.service';
import { ContactService } from '../../../../services/contact.service';
import { UtilityService } from '../../../../services/shared/utility.service';
import { LocalService } from '../../../../services/shared/local.service';
import { NotificationService } from '../../../../services/notification.service';
import { ContactSearchService } from '../../../../services/shared/contact-search.service';
import { IntDropDownItem, IntDropDownItemListResponse, SimpleResponse } from '../../../../models/genericResponse.model';
import { AccountSetupService } from '../../../../services/accountSetup.service';
import { map, Observable, Subscription, Subject, takeUntil } from 'rxjs';
import { ReportService } from '../../../../services/report.service';
import { eButtonActions, eDDField, eRedirectedTo, eSectionLead, eUserRole } from '../../../../models/enum.model';
import { GlobalService } from '../../../../services/global.service';
import { TagSettingService } from '../../../../services/tag-setting.service';
import { TagData } from '../../../../models/tag-settings.model';
import { EngageMetricService } from '../../../../services/engage-metric.service';
import { ClassCodeService } from '../../../../services/classCode.service';
import { DatePipe } from '@progress/kendo-angular-intl';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ClpCompany, CompanyResponse } from '../../../../models/company.model';
import { AppconfigService } from '../../../../services/shared/appconfig.service';
import { ConfigDetails } from '../../../../models/appConfig.model';
import { isNullOrEmptyString } from '../../../../../shared/utils';
declare var $: any;

@Component({
    selector: 'bulk-contact-common',
    templateUrl: './bulk-contact-common.component.html',
    styleUrls: ['./bulk-contact-common.component.css'],
    providers: [GridConfigurationService, ContactCommonSearchService, DatePipe]
})
export class BulkContactCommonComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    private intervals = new Set<ReturnType<typeof setInterval>>();

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    contactsArchiveDataSource: MatTableDataSource<any>;
    contactsArchiveDataDisplayColumns: string[] = [];
    eUserRole = eUserRole;
    showSpinner: boolean = false;
    private encryptedUser: string = '';
    @Input() user: CLPUser;
    @Input() roleFeaturePermissions: RoleFeaturePermissions;
    contactsArchiveData: ContactList[] = [];
    queryDataLoaded: SearchQueryResponse;
    bulkActionResponse: BulkActionResponse;
    public clickUser: IntDropDownItem[];
    public fieldDropdown: any = [];
    dateFormat: string = "MM/dd/yyyy";
    public editTypeDropdown: [];
    userResponse: UserResponse;
    initContactsArchiveData: ContactList[];
    isShowNoRecords: boolean = false;
    contactListResponse: ContactListResponse;
    isCustomSearch: boolean = false;
    isEditType: boolean = false;
    EditTypeMessage: String = ""
    isSelectAllCheckBox: boolean = false;
    showButton: boolean = false;
    columns = [
        { field: '$', title: ' ', width: '40' },
        { field: '$$', title: '  ', width: '40' },
        { field: 'name', title: 'Name', width: '250' },
        { field: 'email', title: 'Email', width: '70' },
        { field: 'companyName', title: 'Company', width: '350' },
        //{ field: 'address', title: 'Address', width: '120' },
        //{ field: 'city', title: 'City', width: '80' },
        //{ field: 'state', title: 'State', width: '80' },
        //{ field: 'country', title: 'Country', width: '80' },
        //{ field: 'zip', title: 'Zip', width: '60' },
        //{ field: 'emailAddress', title: 'Email Address', width: '140' },
        { field: 'phone', title: 'Phone', width: '120' },
        { field: 'userName', title: 'User', width: '120' },
        { field: 'dtModifiedDisplay', title: 'Modified', width: '100' },
        { field: 'dtCreatedDisplay', title: 'Created', width: '90' },
        { field: 'action', title: '', width: '90' },
    ];
    //reorderColumnName: string = 'name,email,companyName,address:h,city:h,state:h,country:h,zip:h,emailAddress:h,phone,userName,dtModifiedDisplay,dtCreatedDisplay';
    reorderColumnName: string = 'name,email,companyName,phone,userName,dtModifiedDisplay,dtCreatedDisplay';
    columnWidth: string = 'name:250,email:70,companyName:350,address:120,city:80,state:80,country:80,zip:60,emailAddress:140,phone:120,userName:120,dtModifiedDisplay:100,dtCreatedDisplay:90';
    arrColumnWidth: any[] = ['name:250,email:70,companyName:350,address:120,city:80,state:80,country:80,zip:60,emailAddress:140,phone:120,userName:120,dtModifiedDisplay:100,dtCreatedDisplay:90'];
    @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;

    public mySelection: number[] = [];
    gridHeight;
    engageUrl: any;
    sendMailInfo: any = { isShow: false, contactId: 0 };
    //@Output() sendMailInfo: EventEmitter<{ isShow: boolean, contactId: 0 }> = new EventEmitter<any>();
    selectAllContacts: boolean = false;
    isSelectAction: boolean = false;
    isDeleteContact: boolean = false;
    isSelectActionButton: boolean = false;
    transferOwner: boolean = false;
    isEditField: boolean = false;
    isTagSelected: boolean = false;
    isMoreFieldSelected: boolean = false;
    isConfirm: boolean = false;
    bulkEditFieldForm: FormGroup;
    bulkTransferFieldForm: FormGroup;
    mobileColumnNames: string[];
    selectedTagId: number = 0;
    paramSubscriptionUser: Subscription;
    csId: number = 0;
    customSearchContact: Contact[];
    buttonTypeOperation: eButtonActions = eButtonActions.None;
    saveConfirmation: boolean
    tagListByCompany: TagData[];
    isClearSelected: boolean = false;
    metricNames: string[];
    fieldCategory: any = '';
    classCodes: IntDropDownItem[] = [];
    contactsCountAll: number = 0;
    co: ClpCompany;
    showTransferSFA: boolean = false;
    //totalContactCount: number = 0;
    constructor(private _appConfigService: AppconfigService,
        public _bulkActionContactService: BulkActionContactService,
        public _contactService: ContactService,
        private _utilityService: UtilityService,
        public _localService: LocalService,
        private _router: Router,
        private fb: FormBuilder,
        public _gridCnfgService: GridConfigurationService,
        private _notifyService: NotificationService,
        public _contactSearchService: ContactSearchService,
        public _accountSetupService: AccountSetupService,
        private _route: ActivatedRoute,
        private _contactCommonSearchService: ContactCommonSearchService,
        private _tagSettingService: TagSettingService,
        private _ngZone: NgZone,
        private date: DatePipe,
        private engageMetricService: EngageMetricService,
        private _classCodeService: ClassCodeService,
        private _globalService: GlobalService,
        private _reportService: ReportService) {
        //this.gridHeight = this._localService.getGridHeight('499px');

        //Get route Parameters
        this.paramSubscriptionUser = this._route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(async params => {
            if (params?.csId) {
                this.csId = +params['csId'];
                this.isCustomSearch = true;
            }
        });

        this.subscribeToEvents();
    }



    ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                if (this.user) {
                    this.dateFormat = this.user.dateFormat;
                    this.getEnv();
                    //Kendo grid load call stopped.
                    //this.getGridConfiguration();
                    this.getTagListByCompany()

                    if (this.isCustomSearch)
                        this.getContactsCsId();

                    this.loadCompany();
                }
                else
                    this._router.navigate(['/login']);
            }
            else
                this._router.navigate(['/login']);
        });
    }

    async loadCompany() {
        await this._accountSetupService.loadCompany(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: CompanyResponse) => {
                if (result) {
                    this.co = UtilityService.clone(result.company);

                    if (this.co?.isSFAIncluded) {
                        if (this.user?.slurpyUserId > 0)
                            this.showTransferSFA = true;
                        else if (this.user?.cLPUserID == 1)
                            this.showTransferSFA = true;
                    }
                }

            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    getArchiveContacts() {
        if (!isNullOrUndefined(this._gridCnfgService)) {
            this._gridCnfgService.iterateConfigGrid(true, "contact_bulk_action_grid");
            this.mobileColumnNames = this._gridCnfgService.getResponsiveGridColums('contact_bulk_action_grid');
        }
    }

    prepareBulkEditFieldForm() {
        return this.fb.group({
            ddField: new FormControl(''),
            editType: new FormControl(-1),
            textValue: new FormControl(''),
            ddFTValue: new FormControl(0),
            metricName: new FormControl(''),
            ddValue: new FormControl(0),
            cbValue: new FormControl(false),
            cmValue: new FormControl(''),
            txtDateValue: new FormControl(''),
        });
    }
    prepareBulkTransferFieldForm() {
        return this.fb.group({
            ddValue: new FormControl(this.user?.cLPUserID),
            trTransferSFA: new FormControl(false),
            cbTransferSFA: new FormControl(false),
        });
    }

    showColumn(columnDef): boolean {
        var value = true;
        if (columnDef) {
            (columnDef == 'email') || (columnDef == 'phone') ? value = false : value = true;
        }
        return value;
    }
    gotoLink(event = null, columnName, dataItem) {
        var url = this.engageUrl;
        if (columnName) {
            switch (columnName) {
                case "address-card":
                case "name": {
                    if (this.user.timeZoneWinId != 0) {
                        let url = '/contact/' + dataItem.contactID;
                        return url;
                    }
                    else {
                        if (confirm("First , Please select your timezone!!!"))
                            this._router.navigate(['/edit-profile', dataItem.clpUserId]);
                        else
                            return;
                    }
                    break;
                }
                case "userName": {
                    return `/edit-profile/${dataItem.clpUserId}`;
                }
                case "email": {
                    $('#sendEmail').modal('show');
                    //this.sendMailInfo.emit({ isShow: true, contactId: dataItem?.contactID });
                    this.sendMailInfo.isShow = true;
                    this.sendMailInfo.contactId = dataItem?.contactID;
                    break;
                }
                case "companyName": {
                    return `company-create?cid=${dataItem?.coCompanyID}`;
                }
                default: {
                    break;
                }
            }
        }
    }

    hideSendMail() {
        $('#sendEmail').modal('hide');
        this.sendMailInfo.isShow = false;
        this.sendMailInfo.contactId = 0;
    }

    async getBulkActionDropdown() {
        this.showSpinner = true;
        await this._bulkActionContactService.getBulkActionDropdown(this.encryptedUser, this.user.cLPCompanyID, this.user.cLPUserID)
            .then(async (result: BulkActionResponse) => {
                if (result) {
                    this.bulkActionResponse = UtilityService.clone(result);
                    this.fieldDropdown = this.bulkActionResponse.dynamicList;
                    this.editTypeDropdown = this.bulkActionResponse.eEditTypeName;
                    this.showSpinner = false;
                } else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("bulk-contact-common.getBulkActionDropdown", err.message, null, '');
                this._utilityService.handleErrorResponse(err);
            });
    }

    async updateContactApi(updateContact: BulckAction) {
        this.showSpinner = true;
        this.buttonTypeOperation = eButtonActions.Save;

        await this._bulkActionContactService.updateBulkContacts(this.encryptedUser, this.user?.cLPUserID, 0, updateContact.editType, this.user?.cLPCompanyID, updateContact)
            .then(async (result: BulkActionResponse) => {
                if (result.statusCode == 0) {
                    this.EditTypeMessage = ""
                    this._notifyService.showSuccess('', result.messageString, 3000);
                    this.showSpinner = false;
                    $("#drpSavedQueries").val(0)
                    this.buttonTypeOperation = eButtonActions.None;
                    this.contactsArchiveData = [];
                    this.mySelection = [];
                    this.cancelBulkAction();
                }
                else if (result.statusCode == 1) {
                    this._notifyService.showError('', 'Contact Not Update');
                    this.showSpinner = false;
                    this.buttonTypeOperation = eButtonActions.None;
                    this.contactsArchiveData = [];
                    this.cancelBulkAction();
                    this.mySelection = [];
                }
                this.isConfirm = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("bulk-contact-common.updateContactApi", err.message, updateContact,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                    + ' cLPUserID: ' + this.user.cLPUserID
                    + ' editType: ' + updateContact.editType
                );
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
                this.buttonTypeOperation = eButtonActions.None;
                this.contactsArchiveData = [];
                this.cancelBulkAction();
                this.mySelection = [];
                this.isConfirm = false;
            });
    }

    async deleteContactApi(updateContact: BulckAction, supportLogin) {
        this.showSpinner = true;
        this.buttonTypeOperation = eButtonActions.Delete;
        console.log(updateContact);
        this._bulkActionContactService.getBulkContactsDelete(this.encryptedUser, this.user.cLPUserID, this.user.cLPCompanyID, supportLogin, this.user.cLPSSID, updateContact)
            .then(async (result: SimpleResponse) => {
                if (result.messageBool) {
                    if (result.statusCode == 200)
                        this._notifyService.showSuccess('', result.messageString, 3000);
                    else if (result.statusCode == 204)
                        this._notifyService.showWarning('', result.messageString);
                    else if (result.statusCode == 1)
                        this._notifyService.showWarning('', 'Something Went Wrong!');
                    this.showSpinner = false;
                    this.buttonTypeOperation = eButtonActions.None;
                    this.contactsArchiveData = [];
                    this.mySelection = [];
                }
                else {
                    this._notifyService.showError('', 'Something Went Wrong!', 3000);
                    this.showSpinner = false;
                    this.buttonTypeOperation = eButtonActions.None;
                    this.contactsArchiveData = [];
                    this.mySelection = [];
                    this.cancelBulkAction();
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("bulk-contact-common.deleteContactApi", err.message, updateContact,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                    + ' cLPUserID: ' + this.user.cLPUserID
                    + ' editType: ' + updateContact.editType
                );
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
                this.buttonTypeOperation = eButtonActions.None;
                this.contactsArchiveData = [];
                this.mySelection = [];
            });
    }

    async transferContactApi(updateContact: BulckAction) {
        if (updateContact.ddValue != '0') {
            this.showSpinner = true;
            this.buttonTypeOperation = eButtonActions.Transfer;
            await this._bulkActionContactService.transferBulkContacts(this.encryptedUser, this.user.cLPUserID, this.user.cLPCompanyID, updateContact)
                .then(async (result: SimpleResponse) => {
                    if (result) {
                        this._notifyService.showSuccess(result.messageString, 'Contact Transfered Successful', 3000);
                        this.showSpinner = false;
                        this.contactsArchiveData = [];
                        this.mySelection = [];
                        this.cancelBulkAction();
                        this.buttonTypeOperation = eButtonActions.None;
                    }
                    else {
                        this.showSpinner = false;
                        this.contactsArchiveData = [];
                        this.mySelection = [];
                        this.cancelBulkAction();
                        this.buttonTypeOperation = eButtonActions.None;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("bulk-contact-common.transferContactApi", err.message, updateContact,
                        'cLPCompanyID: ' + this.user.cLPCompanyID
                        + ' cLPUserID: ' + this.user.cLPUserID
                    );
                    this._utilityService.handleErrorResponse(err);
                    this.showSpinner = false;
                    this.contactsArchiveData = [];
                    this.mySelection = [];
                    this.cancelBulkAction();
                    this.buttonTypeOperation = eButtonActions.None;
                });
        }
        else
            this._notifyService.showError('', 'Select a owner', 3000);
    }
    async getDropdownFields() {
        this.showSpinner = true;
        await this._accountSetupService.loadUsers(this.encryptedUser, this.user.cLPUserID, this.user.cLPCompanyID)
            .then(async (result: SFAResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.clickUser = response?.userList;
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("bulk-contact-common.getDropdownFields", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                );
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    onTagValueChange(value: any): void {
        const matchedItem = this.tagListByCompany.find(item => item.tagID === value || item.tagDisplay === value);

        if (matchedItem) {
            this.selectedTagId = matchedItem.tagID;
        } else {
            this.selectedTagId = 0;
        }
    }

    updateContacts() {
        let contactUpdateSelected: BulckAction = <BulckAction>{};
        contactUpdateSelected.syncCode = null;
        contactUpdateSelected.cbAction = true;
        contactUpdateSelected.cmValue = this.bulkEditFieldForm.controls.cmValue.value;
        contactUpdateSelected.textValue = this.bulkEditFieldForm.controls.textValue.value;
        contactUpdateSelected.ddFTValue = this.bulkEditFieldForm.controls.ddFTValue.value;
        contactUpdateSelected.metricName = this.bulkEditFieldForm.controls.metricName.value;
        contactUpdateSelected.ddField = this.bulkEditFieldForm.controls.ddField.value;
        contactUpdateSelected.ddValue = this.bulkEditFieldForm.controls.ddValue.value;
        contactUpdateSelected.cbValue = this.bulkEditFieldForm.controls.cbValue.value;
        contactUpdateSelected.txtDateValue = this.date.transform(this.bulkEditFieldForm.controls.txtDateValue.value, 'MMddyyyy');
        contactUpdateSelected.editType = this.bulkEditFieldForm.controls.editType.value;
        contactUpdateSelected.searchQuery = this.queryDataLoaded;
        contactUpdateSelected.selectedTagId = this.selectedTagId;
        if (this.selectAllContacts) {
            contactUpdateSelected.processAll = true;
            if (this.isCustomSearch && isNullOrEmptyString(this.queryDataLoaded)) {
                contactUpdateSelected.csId = this.csId;
            }
        }
        else {
            contactUpdateSelected.processAll = false;
            contactUpdateSelected.bulkRequestID = this.mySelection;
        }
        this.updateContactApi(contactUpdateSelected);

    }

    deleteContacts() {
        let contactUpdateSelected: BulckAction = <BulckAction>{};
        contactUpdateSelected.searchQuery = this.queryDataLoaded;
        let supportLogin = null;
        contactUpdateSelected.syncCode = null;
        if (this.selectAllContacts) {
            this.mySelection = [];
            this.contactsArchiveDataSource.data.forEach(i => {
                this.mySelection.push(i.contactID)
            })
            contactUpdateSelected.processAll = true;
            if (this.isCustomSearch && isNullOrEmptyString(this.queryDataLoaded)) {
                contactUpdateSelected.csId = this.csId;
            }
        }
        else {
            if (this.isSelectAllCheckBox) {
                let selection: any = this.mySelection;
                contactUpdateSelected.bulkRequestID = [];
                selection.forEach(i => {
                    contactUpdateSelected.bulkRequestID.push(i.contactID)
                });
            }
            else {
                contactUpdateSelected.bulkRequestID = this.mySelection;
            }
            contactUpdateSelected.processAll = false;
        }
        this.deleteContactApi(contactUpdateSelected, supportLogin);
    }



    transferContacts() {
        let contactUpdateSelected: BulckAction = <BulckAction>{};
        contactUpdateSelected.syncCode = null;
        contactUpdateSelected.cbAction = true;
        contactUpdateSelected.ddValue = this.bulkTransferFieldForm.controls.ddValue.value;
        contactUpdateSelected.trTransferSFA = this.bulkTransferFieldForm.controls.trTransferSFA.value;
        contactUpdateSelected.cbTransferSFA = this.bulkTransferFieldForm.controls.cbTransferSFA.value;
        contactUpdateSelected.searchQuery = this.queryDataLoaded;
        if (this.selectAllContacts) {
            contactUpdateSelected.processAll = true;
            if (this.isCustomSearch && isNullOrEmptyString(this.queryDataLoaded)) {
                contactUpdateSelected.csId = this.csId;
            }
        }
        else {
            contactUpdateSelected.processAll = false;
            contactUpdateSelected.bulkRequestID = this.mySelection;
        }
        this.transferContactApi(contactUpdateSelected);

    }
    cancelBulkAction() {
        this.contactsCountAll = 0;
        this.isSelectAction = false;
        this.isSelectActionButton = false;
        this.isEditField = false;
        this.contactsArchiveData = [];
        this.contactsArchiveDataDisplayColumns = [];
        this.contactsArchiveDataSource.data = [];
        this.mySelection = [];
        this.transferOwner = false;
        this.isConfirm = false;
        this.selectedTagId = 0;
    }
    selectAction() {
        this.getBulkActionDropdown();
        this.isSelectAction = true;
        this.isSelectActionButton = true;
    }
    editField() {
        this.bulkEditFieldForm = this.prepareBulkEditFieldForm();
        this.isEditField = true;
        this.isSelectActionButton = false;
        this.transferOwner = false;
        this.EditTypeMessage = "Please select the field you would like to edit."
    }
    transferOwnerField() {
        this.bulkTransferFieldForm = this.prepareBulkTransferFieldForm();
        this.getDropdownFields();
        this.transferOwner = true;
        this.isEditField = false;
        this.isSelectActionButton = false;
    }
    onChangeField(event) {
        this.classCodes = [];
        let e = event?.target?.value;
        this.fieldCategory = this.fieldDropdown.filter((item: any) => item?.name == e)[0]?.category;
        this.EditTypeMessage = "Please select the type of edit you would like to perform on this field."
        switch (e) {
            case "Shareable": case "OutlookSync": case "CMCustomDate1": case "CMCustomDate2": case "CMCustomDate1":
                this.isMoreFieldSelected = true;

                break;
            case "Class1Code":
                this.isMoreFieldSelected = true;
                this.getClassCode(eDDField.Class1Code);
                break;
            case "Class2Code":
                this.isMoreFieldSelected = true;
                this.getClassCode(eDDField.Class2Code);
                break;
            case "Class3Code":
                this.isMoreFieldSelected = true;
                this.getClassCode(eDDField.Class3Code);
                break;
            case "Class4Code":
                this.isMoreFieldSelected = true;
                this.getClassCode(eDDField.Class4Code);
                break;
            case "Class5Code":
                this.isMoreFieldSelected = true;
                this.getClassCode(eDDField.Class5Code);
                break;
            case "Class6Code":
                this.isMoreFieldSelected = true;
                this.getClassCode(eDDField.Class6Code);
                break;
            case "Class7Code":
                this.isMoreFieldSelected = true;
                this.getClassCode(eDDField.Class7Code);
                break;
            case "Class8Code":
                this.isMoreFieldSelected = true;
                this.getClassCode(eDDField.Class8Code);
                break;
            case "Tag":
            case "EngageMetric":
                this.isTagSelected = true;
                this.isClearSelected = true;
                this.isMoreFieldSelected = false;
                this.loadMetricNamesbyCompanyID();
                break;
            case "isOptOutTxtMsg":
            case "EmailInfoSubscribe":
            case "EmailPromoSubscribe":
                this.isTagSelected = false;
                this.isClearSelected = true;
                this.isMoreFieldSelected = true;
                break;
            default:
                this.isTagSelected = false;
                this.isClearSelected = false;
                this.isMoreFieldSelected = false;
                this.isEditType = true;
        }
    }

    async getClassCode(classCodeNum) {
        this.showSpinner = true;
        await this._classCodeService.GetClassCodesDD(this.encryptedUser, classCodeNum, this.user?.cLPCompanyID)
            .then(async (result: IntDropDownItemListResponse) => {
                if (!isNullOrUndefined(result))
                    this.classCodes = UtilityService.clone(result?.intDropDownItemList);
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("contact.getLoadClass4Code", err.message, null,
                    'cLPCompanyID: ' + this.user?.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    onChangeEditType(e) {
        this.isEditType = false;
        switch (e) {
            case "0":
                this.EditTypeMessage = "Please select the new value."
                break;
            case "1":
                this.EditTypeMessage = "Please select the value you would like to add."
                break;
            case "2":
                this.EditTypeMessage = "Please select the new value."
                break;
            case "3":
                this.EditTypeMessage = "Please select the item you would like to remove."
                break;
        }
    }
    onContactArchiveListFilter(inputValue: string): void {
        //this.contactsArchiveData = process(this.initContactsArchiveData, {
        //    filter: {
        //        logic: "or",
        //        filters: [
        //            { field: 'name', operator: 'contains', value: inputValue },
        //            { field: 'email', operator: 'contains', value: inputValue }

        //        ],
        //    }
        //}).data;
        //if (!isNullOrUndefined(this.dataBinding) && !isNullOrUndefined(this.dataBinding.skip))
        //    this.dataBinding.skip = 0;

        inputValue = inputValue.trim().toLowerCase();

        if (this.contactsArchiveDataSource) {
            this.contactsArchiveDataSource.filterPredicate = (data: any, filter: string) => {
                return Object.keys(data).some((key) => {
                    return data[key]?.toString().toLowerCase().includes(filter);
                });
            };

            this.contactsArchiveDataSource.filter = inputValue;
        }
    }

    async getContactsCsId() {
        await this._reportService.getContactsByCustomSearchId(this.encryptedUser, this.user?.cLPCompanyID, this.csId, this.user?.cLPUserID, eRedirectedTo.bulkContacts)
            .then(async (result: ContactResponse) => {
                if (!isNullOrUndefined(result)) {
                    var response = UtilityService.clone(result);
                    this.customSearchContact = response.contactList;
                    this.contactsCountAll = response.messageInt;
                    this.contactsArchiveData = [];
                    this.customSearchContact?.forEach(x => {
                        var contactsArchiveData: ContactList = <ContactList>{};
                        contactsArchiveData.contactID = x.contactID;
                        contactsArchiveData.name = x.firstName + ' ' + x.lastName;
                        contactsArchiveData.firstName = x.firstName;
                        contactsArchiveData.lastName = x.lastName;
                        contactsArchiveData.email = x.email;
                        contactsArchiveData.companyName = x.companyName;
                        contactsArchiveData.phone = this._localService?.maskNumbersInString(x.phone, this.user);
                        contactsArchiveData.mobile = x.mobile;
                        contactsArchiveData.homePhone = x.homePhone;
                        contactsArchiveData.add1 = x.add1;
                        contactsArchiveData.add2 = x.add2;
                        contactsArchiveData.add3 = x.add3;
                        contactsArchiveData.city = x.city;
                        contactsArchiveData.state = x.state;
                        contactsArchiveData.zip = x.zip;
                        contactsArchiveData.country = x.country;
                        contactsArchiveData.dtModified = new Date(x.dtModified);
                        contactsArchiveData.dtCreated = new Date(x.dtCreated);
                        contactsArchiveData.dtModifiedDisplay = new Date(x.dtModified);
                        contactsArchiveData.dtCreatedDisplay = new Date(x.dtCreated);
                        contactsArchiveData.userName = x.uFirstName + ' ' + x.uLastName;
                        contactsArchiveData.uFirstName = x.uFirstName;
                        contactsArchiveData.uLastName = x.uLastName;
                        contactsArchiveData.clpUserId = x.cLPUserID;
                        contactsArchiveData.class1Code = x.class1Code;
                        this.contactsArchiveData.push(contactsArchiveData);
                    });

                    this.setGrid(this.contactsArchiveData);
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("bulk-contact-common.getContactsCsId", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                    + 'cLPUserID: ' + this.user.cLPUserID
                    + 'csId: ' + this.csId
                    + 'bulkContacts: ' + eRedirectedTo.bulkContacts
                );
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    getNewOwnerName(ddValue) {
        let name = this.clickUser.filter(item => item.id == ddValue)
        return name[0]?.text
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();

        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();

        this.intervals.forEach(id => clearInterval(id));
        this.intervals.clear();
    }

    private subscribeToEvents(): void {
        this._contactCommonSearchService.contactListChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.contactsArchiveData = data;
                if (this.contactsArchiveData?.length > 0) {
                    this.contactsArchiveData.forEach((item) => {
                        item.phone = this._localService.maskNumbersInString(item?.phone, this.user);
                    })

                    this.addTimeout(() => {
                        this.setGrid(this.contactsArchiveData);
                    }, 10);
                    this.isShowNoRecords = false;
                }
                else {

                    this.contactsArchiveData = [];
                    this.contactsArchiveDataDisplayColumns = [];
                    this.contactsArchiveDataSource = new MatTableDataSource([]);
                    this.isShowNoRecords = true;

                }
                this.initContactsArchiveData = data;
            })
        });
        this._contactCommonSearchService.queryListChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.queryDataLoaded = data;
                this.isCustomSearch = false;
            })
        });
        this._contactCommonSearchService.contactCountChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.contactsCountAll = data;
            })
        });
    }

    async getTagListByCompany() {
        await this._tagSettingService.tag_GetListByCLPCompany(this.encryptedUser, this.user?.cLPCompanyID, 2)
            .then(async (result: TagData[]) => {
                if (!isNullOrUndefined(result)) {
                    this.tagListByCompany = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("bulk-contact-common.getTagListByCompany", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadMetricNamesbyCompanyID() {
        await this.engageMetricService.loadMetricNamesbyCompanyID(this.encryptedUser, this.user?.cLPCompanyID)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.metricNames = UtilityService.clone(result?.messageArray);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("bulk-contact-common.getTagListByCompany", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getValue(ddFieldValue) {

        if (this.fieldCategory == 'text') {
            return this.bulkEditFieldForm.controls.textValue.value;
        }
        else if (this.fieldCategory == 'dropDown') {
            switch (ddFieldValue) {
                case 'Tag':
                    let tagId = +this.bulkEditFieldForm.controls.cmValue.value;
                    if (tagId > 0) {
                        if (this.tagListByCompany?.length > 0) {
                            let tagName = this.tagListByCompany.filter((item) => item?.tagID == tagId)[0]?.tagDisplay;
                            return tagName;
                        }
                    }
                    else {
                        return this.bulkEditFieldForm.controls.cmValue.value;
                    }
                    break;
                case 'EngageMetric':
                    let metricValue = this.bulkEditFieldForm.controls.textValue.value;
                    if (metricValue != '') {
                        return metricValue;
                    }
                    break;
                case 'isOptOutTxtMsg':
                    let value = +this.bulkEditFieldForm.controls.ddFTValue.value;
                    if (value == 1) {
                        return 'Opt In';
                    }
                    if (value == 3) {
                        return 'Opt Out';
                    }
                    break;
                case 'EmailInfoSubscribe':
                case 'EmailPromoSubscribe':
                    let emailInfoOrPromo = +this.bulkEditFieldForm.controls.ddFTValue.value;
                    if (emailInfoOrPromo == 1) {
                        return 'Opt In';
                    }
                    if (emailInfoOrPromo == 3) {
                        return 'UnSubscribe';
                    }
                    break;
                default:
                    let classCodeValue = +this.bulkEditFieldForm.controls.ddValue.value;
                    let classCodeName = this.classCodes.filter((item) => item?.id == classCodeValue)[0]?.text;
                    return classCodeName;
            }
        }
        else if (this.fieldCategory == 'date') {
            let formatedDt = this.date.transform(this.bulkEditFieldForm.controls.txtDateValue.value, 'MM/dd/yyyy');
            return formatedDt;
        }
        else if (this.fieldCategory == 'check') {
            return this.bulkEditFieldForm.controls.cbValue.value ? 'Checked' : 'UnChecked';
        }
        return '';
    }

    setTotalContactCount(event: number) {
        //this.totalContactCount = event;
        this.contactsCountAll = event;
    }

    setGrid(list) {
        this.contactsArchiveDataDisplayColumns = this.columns.map(c => c.field);
        this.contactsArchiveDataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.contactsArchiveDataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('contact_bulk_action_grid') ? this._localService.getPageSize('contact_bulk_action_grid') : 50;
            }
            if (this.sort) {
                this.contactsArchiveDataSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('contact_bulk_action_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500)
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    toggleSelection(row: any) {
        const index = this.mySelection.indexOf(row.contactID);
        if (index === -1) {
            this.mySelection.push(row.contactID);
        } else {
            this.mySelection.splice(index, 1);
        }
    }

    isSelected(row: any): boolean {
        return this.mySelection.includes(row.contactID);
    }


    toggleSelectAll(event: any) {
        const pageData = this.getCurrentPageData();
        if (event.checked) {
            pageData.forEach(row => {
                if (!this.mySelection.includes(row.contactID)) {
                    this.mySelection.push(row.contactID);
                }
            });
        } else {
            this.mySelection = this.mySelection.filter(id => !pageData.some(row => row.contactID === id));
        }
    }

    isIndeterminate(): boolean {
        const pageData = this.getCurrentPageData();
        const selectedCount = pageData.filter(row => this.mySelection.includes(row.contactID)).length;
        return selectedCount > 0 && selectedCount < pageData.length;
    }

    getCurrentPageData(): any[] {
        if (!this.paginator || !this.contactsArchiveDataSource) {
            return [];
        }
        const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
        return this.contactsArchiveDataSource.filteredData.slice(startIndex, startIndex + this.paginator.pageSize);
    }


    validateBulkAction() {
        if (this.bulkEditFieldForm.controls.ddField.value == 'EngageMetric' && this.bulkEditFieldForm.controls.metricName.value == '') {
            this._notifyService.showError('', 'Please select a valid Metric.', 3000);
            this.EditTypeMessage = '';
        }
        else {
            this.isConfirm = true;
            this.EditTypeMessage = 'Please confirm the field and value you would like to edit for all checked contacts.'
        }
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }


    bulkAction() {
        this._bulkActionContactService.bulkAction(this.encryptedUser, this.user?.cLPUserID, this.user?.cLPCompanyID)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    /* = UtilityService.clone(result?.messageBool);*/
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("bulk-contact-common.getTagListByCompany", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID);
                this._utilityService.handleErrorResponse(err);
            });
    }


    getEnv() {
        this._appConfigService.getAppConfigValue(this.encryptedUser, "environment")
            .then(async (result: ConfigDetails) => {
                if (!isNullOrEmptyString(result?.configValue)) {
                    if (result?.configValue.toLowerCase() == "prod") {
                        this.showButton = false;
                    }
                    else {
                        this.showButton = true;
                    }
                }

            });

    }
}
